import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useLogin } from '@/api/auth';
import type { LoginRequest } from '@/types/api';

declare global {
  interface Window {
    __OPS_MODE__?: boolean;
  }
}

const LoginPage: React.FC = () => {
  const login = useLogin();
  const isOps = window.__OPS_MODE__ === true;

  const onFinish = (values: LoginRequest) => {
    login.mutate(values, {
      onError: (error: unknown) => {
        const msg =
          (error as { response?: { data?: { message?: string } } })?.response?.data
            ?.message || '登录失败';
        message.error(msg);
      },
    });
  };

  const title = isOps ? '场站运维中台' : '山东电力现货与运营综合中台';
  const subtitle = isOps ? 'AGC实时监控 · 数据上传' : '请登录';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f3f4f6',
      }}
    >
      <Card style={{ width: '100%', maxWidth: 400, margin: '0 16px', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⚡</div>
          <h2 style={{ margin: 0, color: '#374151' }}>{title}</h2>
          <p style={{ color: '#9ca3af', marginTop: 8 }}>{subtitle}</p>
        </div>
        <Form<LoginRequest>
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input placeholder="用户名" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={login.isPending}
              block
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
